
import React, { useEffect, useState } from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import ColorTextBox from '../common/ColorTextBox';

const classNames = mergeStyleSets({
    dialogContent: {
    }
});

const DialogContentCategoryItem = (props) => {

    const [color, setColor] = useState(props.color || '255 255 255');
    const [title, setTitle] = useState(props.title || '');

    useEffect(() => {
        if (props.onChangeColor) {
            props.onChangeColor(color);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [color]);

    useEffect(() => {
        if (props.onChangeTitle) {
            props.onChangeTitle(title);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title]);

    const handleChangeColor = (value) => {
        setColor(value);
    }

    const handleChangeTitle = (event) => {
        setTitle(event.target.value);
    }

    return (
        <div className={classNames.dialogContent}>
            <TextField
                label="Název položky"
                value={title}
                onChange={handleChangeTitle}
            />
            <ColorTextBox
                label="Barva položky"
                value={color}
                onChange={handleChangeColor}
            />
        </div>
    );
}

export default DialogContentCategoryItem;
